var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.644,
    height: 14.954,
    viewBox: "0 0 14.644 14.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 12.607,
    height: 14.954,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(-24 -256.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(26.037 256.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M34.559,181.484c-.335-.157-.688-.269-1.034-.4-1.052-.4-2.106-.789-3.159-1.183-.342-.128-.408-.225-.408-.583,0-.219,0-.438,0-.657,0-.112.023-.165.15-.17a1.311,1.311,0,0,0,1.112-.622,1.3,1.3,0,0,0,.2-.707,12.086,12.086,0,0,0-.019-1.3,1.3,1.3,0,0,0-1.119-1.121c-.376-.043-.313.049-.319-.35,0-.2.016-.41,0-.612a.466.466,0,0,1,.654-.458c.509.207,1.03.388,1.545.58.766.286,1.53.578,2.3.856a.27.27,0,0,1,.209.3c-.006,2.072,0,4.144,0,6.216,0,.068-.006.136-.01.2Z",
    transform: "translate(-28.784 -166.53)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M172.535,181.381c0-.058-.01-.116-.01-.174q0-3.137,0-6.274a.236.236,0,0,1,.181-.264c1.256-.464,2.509-.936,3.763-1.4a.619.619,0,0,1,.451-.061.439.439,0,0,1,.306.417c0,.287,0,.574,0,.861,0,.1-.028.138-.132.142a1.325,1.325,0,0,0-1.128.621,1.291,1.291,0,0,0-.2.707,11.937,11.937,0,0,0,.021,1.326,1.3,1.3,0,0,0,1.1,1.091c.337.032.337.032.337.366,0,.185,0,.37,0,.554a.444.444,0,0,1-.339.484c-.582.221-1.167.438-1.75.656l-2.393.9c-.041.015-.079.037-.118.056Z",
    transform: "translate(-165.795 -166.427)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M99.912,0a2.506,2.506,0,0,1,2.5,2.49,2.5,2.5,0,1,1-5.006-.02A2.508,2.508,0,0,1,99.912,0",
    transform: "translate(-93.608 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M77.7,138.6c-.047-.015-.089-.027-.13-.042l-3.158-1.181c-.159-.059-.161-.076-.035-.181a5.272,5.272,0,0,1,1.354-.824.264.264,0,0,1,.258.015,3.282,3.282,0,0,0,3.4,0,.277.277,0,0,1,.272-.016,5.377,5.377,0,0,1,1.352.828c.116.1.112.118-.038.174l-2.952,1.105c-.109.041-.219.08-.327.119",
    transform: "translate(-71.387 -131.028)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M278.234,231.989a1.034,1.034,0,1,1,.135,2.063h-.307a.437.437,0,0,1-.469-.476q0-.554,0-1.108a.439.439,0,0,1,.481-.479h.161",
    transform: "translate(-266.768 -222.94)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M1.778,232.834c0,.194,0,.389,0,.583a.428.428,0,0,1-.444.441,2.242,2.242,0,0,1-.567-.027,1.037,1.037,0,0,1,.068-2.02,1.911,1.911,0,0,1,.6,0,.42.42,0,0,1,.345.414c0,.2,0,.408,0,.612",
    transform: "translate(0 -222.749)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 7,
    height: 2.5,
    rx: 1.25,
    transform: "translate(24 265.25)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 7,
    height: 2.5,
    rx: 1.25,
    transform: "translate(26.25 270) rotate(-90)",
    fill: "#2a77eb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportStudents);
export default __webpack_public_path__ + "static/media/importStudents.7592fb4e151b269943a18c7b971d6038.svg";
export { ForwardRef as ReactComponent };